import type { ComponentRegistry } from '@vibesites/runtime';
import {
  Header,
  Hero,
  PropertyOverview,
  SpecialOffers,
  CTASection,
  TabbedCallouts,
  FloorplansList,
  AmenitiesList,
  Gallery,
  GalleryApartments,
  GallerySeparator,
  GalleryCommunity,
  GalleryStrip,
  NeighborhoodSpotlight,
  NeighborhoodMap,
  VirtualTourEmbed,
  ContactForm,
  ContactMap,
  ScheduleTourForm,
  Fees,
  PetPolicy,
  PageHero,
  PageBlurb,
  HeroSolidBG,
  PageIntro,
  Reviews,
  ReviewsCallout,
  ResidentReviews,
  PinnedCallouts,
  SocialFollow,
  SpecialOfferBanner,
  ResidentAccess,
  ApplyNow,
  AccessibilityStatement,
  PrivacyPolicyContent,
  SitemapContent,
  HyperlocalHero,
  HyperlocalPageCopy,
  ThankYouContent,
  FutureResidentsClub,
  ApartmentSyncSection,
  Footer,
  Navigation,
  InteractiveMapSection,
  FaqAccordion,
} from './components';

export const registry: ComponentRegistry = {
  Header,
  Hero,
  PropertyOverview,
  SpecialOffers,
  CTASection,
  TabbedCallouts,
  FloorplansList,
  AmenitiesList,
  Gallery,
  GalleryApartments,
  GallerySeparator,
  GalleryCommunity,
  GalleryStrip,
  NeighborhoodSpotlight,
  NeighborhoodMap,
  VirtualTourEmbed,
  ContactForm,
  ContactMap,
  ScheduleTourForm,
  Fees,
  PetPolicy,
  PageHero,
  PageBlurb,
  HeroSolidBG,
  PageIntro,
  Reviews,
  ReviewsCallout,
  ResidentReviews,
  PinnedCallouts,
  SocialFollow,
  SpecialOfferBanner,
  ResidentAccess,
  ApplyNow,
  AccessibilityStatement,
  PrivacyPolicyContent,
  SitemapContent,
  HyperlocalHero,
  HyperlocalPageCopy,
  ThankYouContent,
  FutureResidentsClub,
  ApartmentSyncSection,
  Footer,
  Navigation,
  InteractiveMapSection,
  FaqAccordion,
};

export default registry;
